
import {styled} from '@mui/material'

export const AnalyticsStyle = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8)
}))
